// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__jQulC","inside":"Circle_inside__0Ly7j"};